import { apiPost } from '../client';
import { LONG_TIMEOUT_MS } from '../../config/env';
import type {
  BookingRequest,
  PaymentRequest,
  PaymentResponse,
  PrebookingRequest,
  RentCarAllocateRequest,
  RentCarCancelRequest,
  RentCarCancelResponse,
  RentCarCartResponse,
  RentCarGetLocationsRequest,
  RentCarGetLocationsResponse,
  RentCarSearchRequest,
  RentCarSearchResponse,
  UpdatePassengersRequest,
} from '../types/rentCar';

export function getRentCarLocations(
  body: RentCarGetLocationsRequest = {}
): Promise<RentCarGetLocationsResponse> {
  return apiPost<RentCarGetLocationsRequest, RentCarGetLocationsResponse>(
    'RentCar/GetLocations',
    body
  );
}

export function searchRentCars(body: RentCarSearchRequest): Promise<RentCarSearchResponse> {
  return apiPost<RentCarSearchRequest, RentCarSearchResponse>('RentCar/Search', body);
}

export function allocateRentCar(body: RentCarAllocateRequest): Promise<RentCarCartResponse> {
  return apiPost<RentCarAllocateRequest, RentCarCartResponse>('RentCar/Allocate', body);
}

export function updateRentCarPassengers(
  body: UpdatePassengersRequest
): Promise<RentCarCartResponse> {
  return apiPost<UpdatePassengersRequest, RentCarCartResponse>('RentCar/UpdatePassengers', body);
}

export function makeRentCarPrebooking(body: PrebookingRequest): Promise<RentCarCartResponse> {
  return apiPost<PrebookingRequest, RentCarCartResponse>('RentCar/MakePrebooking', body);
}

/** Async-flagged in the migration guide — uses LONG_TIMEOUT_MS. */
export function finalizeRentCarShopping(body: BookingRequest): Promise<RentCarCartResponse> {
  return apiPost<BookingRequest, RentCarCartResponse>('RentCar/FinalizeShopping', body, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}

export function cancelRentCarOrder(body: RentCarCancelRequest): Promise<RentCarCancelResponse> {
  return apiPost<RentCarCancelRequest, RentCarCancelResponse>('RentCar/CancelOrder', body);
}

/** Shared route (not RentCar-prefixed). Async-flagged — uses LONG_TIMEOUT_MS. */
export function makeRentCarPayment(body: PaymentRequest): Promise<PaymentResponse> {
  return apiPost<PaymentRequest, PaymentResponse>('MakePayment', body, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}
